import { useId } from 'react';

const CouponIcon = ({ width = 115, height = 85, className, ...props }) => {
  const clipId = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 115 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M115 60.3401V78.3501C115 81.5501 112.83 84.1901 110.09 84.1901H4.91C2.2 84.1901 0 81.5901 0 78.3501V60.3401C1.74 59.6301 3.24 58.5201 4.34 57.0701C5.73 55.2901 6.51 53.0801 6.51 50.8101C6.51 46.6101 3.88 42.8001 0 41.2401V23.2301C0 20.1301 2.03 17.6101 4.59 17.4301C4.77 17.4701 4.95 17.5001 5.16 17.4301L5.27 17.3901H109.27C109.38 17.4301 109.48 17.4301 109.63 17.4301C109.7 17.4301 109.81 17.4301 109.91 17.3901C109.95 17.3901 109.98 17.3901 109.98 17.3501H110.09C112.8 17.3501 115 19.9501 115 23.1901V41.2401C111.08 42.7701 108.45 46.6101 108.45 50.8101C108.49 54.9701 111.08 58.8201 115 60.3501V60.3401ZM97.92 32.5801C97.92 31.8001 97.31 31.1901 96.53 31.1901H87.92C87.14 31.1901 86.53 31.8001 86.53 32.5801C86.53 33.3601 87.14 33.9701 87.92 33.9701H96.5C97.28 33.9701 97.89 33.3301 97.92 32.5801ZM97.92 44.7201C97.92 43.9401 97.31 43.3301 96.53 43.3301H87.92C87.14 43.3301 86.53 43.9401 86.53 44.7201C86.53 45.5001 87.14 46.1101 87.92 46.1101H96.5C97.28 46.1101 97.89 45.5001 97.92 44.7201ZM97.92 56.9201C97.92 56.1401 97.31 55.5301 96.53 55.5301H87.92C87.14 55.5301 86.53 56.1401 86.53 56.9201C86.53 57.7001 87.14 58.3101 87.92 58.3101H96.5C97.28 58.2701 97.92 57.6701 97.92 56.9201ZM97.92 69.0601C97.92 68.2801 97.31 67.6701 96.53 67.6701H87.92C87.14 67.6701 86.53 68.2801 86.53 69.0601C86.53 69.8401 87.14 70.4501 87.92 70.4501H96.5C97.28 70.4101 97.89 69.8401 97.92 69.0601ZM75.95 77.8201V74.6901C75.95 73.9101 75.34 73.3001 74.56 73.3001C73.78 73.3001 73.17 73.9101 73.17 74.6901V77.8201C73.17 78.6001 73.78 79.2101 74.56 79.2101C75.27 79.1701 75.91 78.5701 75.95 77.8201ZM75.95 65.0701V61.9401C75.95 61.1601 75.34 60.5501 74.56 60.5501C73.78 60.5501 73.17 61.1601 73.17 61.9401V65.0701C73.17 65.8501 73.78 66.4601 74.56 66.4601C75.27 66.4601 75.91 65.8501 75.95 65.0701ZM75.95 52.3701V49.2401C75.95 48.4601 75.34 47.8501 74.56 47.8501C73.78 47.8501 73.17 48.4601 73.17 49.2401V52.3701C73.17 53.1501 73.78 53.7601 74.56 53.7601C75.27 53.7601 75.91 53.1201 75.95 52.3701ZM75.95 39.6601V36.5601C75.95 35.7801 75.34 35.1701 74.56 35.1701C73.78 35.1701 73.17 35.7801 73.17 36.5601V39.6601C73.17 40.4401 73.78 41.0501 74.56 41.0501C75.27 41.0501 75.91 40.4401 75.95 39.6601ZM75.95 26.9501V23.8201C75.95 23.0401 75.34 22.4301 74.56 22.4301C73.78 22.4301 73.17 23.0401 73.17 23.8201V26.9501C73.17 27.7301 73.78 28.3401 74.56 28.3401C75.27 28.3801 75.91 27.7301 75.95 26.9501Z"
          fill="#FFFFFE"
        />
        <path
          d="M106.07 4.8499L107.96 14.6699H20.47L100.16 0.079904C102.79 -0.450096 105.43 1.6799 106.07 4.8499Z"
          fill="#FFFFFE"
        />
        <path
          d="M44.96 44.7696H36.24L33.53 53.0496L59.05 44.7896L47.64 53.0696L51.98 66.4796L40.58 58.1796L29.16 66.4496C32.36 68.7896 36.3 70.1696 40.57 70.1696C51.28 70.1796 59.98 61.4996 60 50.7896C60 40.0696 51.33 31.3696 40.61 31.3496L44.96 44.7696Z"
          fill="white"
        />
        <path
          d="M40.61 31.3498C29.89 31.3498 21.19 40.0198 21.18 50.7398C21.16 57.1998 24.31 62.9198 29.15 66.4498L33.52 53.0398L22.14 44.7298L36.24 44.7498L40.6 31.3398L40.61 31.3498Z"
          fill="white"
        />
        <path
          d="M44.96 44.7696H36.24L33.53 53.0496L59.05 44.7896L47.64 53.0696L51.98 66.4796L40.58 58.1796L29.16 66.4496C32.36 68.7896 36.3 70.1696 40.57 70.1696C51.28 70.1796 59.98 61.4996 60 50.7896C60 40.0696 51.33 31.3696 40.61 31.3496L44.96 44.7696Z"
          fill="#005972"
        />
        <path
          d="M44.96 44.7696H36.24L33.53 53.0496L59.05 44.7896L47.64 53.0696L51.98 66.4796L40.58 58.1796L29.16 66.4496C32.36 68.7896 36.3 70.1696 40.57 70.1696C51.28 70.1796 59.98 61.4996 60 50.7896C60 40.0696 51.33 31.3696 40.61 31.3496L44.96 44.7696Z"
          fill="#005972"
        />
        <path
          d="M40.61 31.3498C29.89 31.3498 21.19 40.0198 21.18 50.7398C21.16 57.1998 24.31 62.9198 29.15 66.4498L33.52 53.0398L22.14 44.7298L36.24 44.7498L40.6 31.3398L40.61 31.3498Z"
          fill="#005972"
        />
        <path
          d="M40.61 31.3498C29.89 31.3498 21.19 40.0198 21.18 50.7398C21.16 57.1998 24.31 62.9198 29.15 66.4498L33.52 53.0398L22.14 44.7298L36.24 44.7498L40.6 31.3398L40.61 31.3498Z"
          fill="#005972"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="115" height="84.19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CouponIcon;
